import React from "react";
import { BasicInfoSection } from "../BasicInfoSection";
import { StepOneProps } from "../types";

export const StepOne: React.FC<StepOneProps> = ({
  values,
  onChange,
  errors,
  touched,
}) => (
  <div className="step-container">
    <BasicInfoSection
      values={values}
      onChange={onChange}
      errors={errors}
      touched={touched}
    />
  </div>
);
